import React, { useEffect } from 'react';
import './quote.styles.scss';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import ContactUsForm from '@/components/SHARED/contact-us/contact-us-form.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import InfoLinks from '@/components/SHARED/info-links/info-links.component';

const QuotePage = () => {

    useEffect(() => {
        changeDocumentTitle('Gamably | Contact Us');
    }, [])
    return (
        <div className='quote-page'>
            <UnauthLayout>
                <div className='quote-page-content'>
                    <div className='g-card contact-us-card'>
                        <h3>Contact Us!</h3>
                        <hr />
                        <ContactUsForm />
                    </div>
                    <InfoLinks />
                </div>
            </UnauthLayout>
        </div>
    )
}

export default QuotePage